// extracted by mini-css-extract-plugin
module.exports = {"roadmapDate":"roadmap-date_roadmapDate__ussr_"};